require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./solutions-customer-acquisition.json") })
        }
      }, "path---solutions-customer-acquisition");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---solutions-customer-acquisition!./.cache/json/solutions-customer-acquisition.json
// module id = 1491
// module chunks = 231608221292675